import { render, staticRenderFns } from "./PlayerBottomBar.vue?vue&type=template&id=74ff3d15"
import script from "./PlayerBottomBar.vue?vue&type=script&lang=js"
export * from "./PlayerBottomBar.vue?vue&type=script&lang=js"
import style0 from "./PlayerBottomBar.vue?vue&type=style&index=0&id=74ff3d15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports